module.exports = __webpack_public_path__ + "static/img/3250_phase_function_Paper_PointsHejduk_Prediction.fd7526b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3250_phase_function_Paper_PointsHejduk_Prediction.png
// module id = tgAm
// module chunks = 0